import { Route, Routes } from "react-router-dom";

import { RouteAuth } from "@/_old/components/auth/route";
import { DEFAULT_ROUTES } from "@/_old/constants/routes";
import { lazy } from "react";
const ImportMembersPage = lazy(() => import("@/members/import/view"));
const MembersPage = lazy(() => import("@/company/members/view"));
const SubscribersPage = lazy(() => import("@/company/subscribers/view"));
const GroupsPage = lazy(() => import("@/company/groups/view"));
const RemovedMembersPage = lazy(() => import("@/company/removed/view"));

const CompanyRoutes = () => {
  return (
    <Routes>
      <Route
        path={DEFAULT_ROUTES.MEMBERS}
        element={
          <RouteAuth permissions={["read-users"]}>
            <MembersPage />
          </RouteAuth>
        }
      />
      <Route
        path={DEFAULT_ROUTES.MEMBERS_SUBSCRIBERS}
        element={
          <RouteAuth permissions={["read-users"]}>
            <SubscribersPage />
          </RouteAuth>
        }
      />
      <Route
        path={DEFAULT_ROUTES.MEMBERS_REMOVED}
        element={
          <RouteAuth permissions={["read-users"]}>
            <RemovedMembersPage />
          </RouteAuth>
        }
      />
      <Route
        path={DEFAULT_ROUTES.MEMBERS_GROUPS}
        element={
          <RouteAuth permissions={["read-users", "read-company-groups"]}>
            <GroupsPage />
          </RouteAuth>
        }
      />
      <Route
        path={DEFAULT_ROUTES.MEMBERS_IMPORT}
        element={
          <RouteAuth>
            <ImportMembersPage />
          </RouteAuth>
        }
      />
    </Routes>
  );
};

export { CompanyRoutes };
